import Papa from 'papaparse';
import type { z } from 'zod';

export type CsvParseResult<T> = {
  valid: T[];
  invalid: Array<{ row: number; raw: Record<string, unknown>; errors: string[] }>;
};

export async function parseCsv<S extends z.ZodTypeAny>(
  file: File,
  schema: S,
): Promise<CsvParseResult<z.infer<S>>> {
  const result = await new Promise<Papa.ParseResult<Record<string, unknown>>>((resolve, reject) => {
    Papa.parse<Record<string, unknown>>(file, {
      header: true,
      skipEmptyLines: true,
      complete: (res) => resolve(res),
      error: (err) => reject(err),
    });
  });
  const valid: Array<z.infer<S>> = [];
  const invalid: CsvParseResult<z.infer<S>>['invalid'] = [];
  result.data.forEach((row, i) => {
    const r = schema.safeParse(row);
    if (r.success) valid.push(r.data);
    else {
      invalid.push({
        row: i + 2,
        raw: row,
        errors: r.error.errors.map((e) => `${e.path.join('.')}: ${e.message}`),
      });
    }
  });
  return { valid, invalid };
}
